import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import './homepageBannerStyle.css'

//Importing Components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons'

//Importing Assets
import BANNER1 from '../../Assets/images/Landing Page Banners/Banner_1.png'
import BANNER2 from '../../Assets/images/Landing Page Banners/Banner_2.png'
import BANNER3 from '../../Assets/images/Landing Page Banners/Banner_3.png'
import BANNER6 from '../../Assets/images/Landing Page Banners/Banner_6.png'
import BANNER5 from '../../Assets/images/Landing Page Banners/Banner_5.png'

const HomePageBanner = () => {
    const images = [
        BANNER3,
        BANNER2,
        BANNER1,
        BANNER5,
        BANNER6
    ];

    //This data depends upon the Banners - So change according to the Banner
    const navigationData = [
        { searchItem: 'GST Registration' },
        { category: 'Registrations' },
        { searchItem: 'Fire License' },
        { searchItem: 'Digital Signature' },
        { category: 'IT Filing' }
    ]

    const bannerRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const scrollToSlide = (index) => {
        const banner = bannerRef.current;
        if (banner) {
            const offset = index * banner.clientWidth;
            banner.style.transform = `translateX(-${offset}px)`;
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000);  // Change slide every 5 seconds

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        scrollToSlide(currentIndex);
    }, [currentIndex]);

    useEffect(() => {
        const handleResize = () => scrollToSlide(currentIndex);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [currentIndex]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }

    const prevSlide = () => {
        setCurrentIndex(prevIndex => (prevIndex - 1 + images.length) % images.length);
    }

    return (
        <section className="homePageBanner_container">
            <div className='button left'>
                <FontAwesomeIcon icon={faAngleLeft} onClick={prevSlide}></FontAwesomeIcon>
            </div>
            <div className='button right'>
                <FontAwesomeIcon icon={faAngleRight} onClick={nextSlide}></FontAwesomeIcon>
            </div>
            <div className="homePageBanner_content" ref={bannerRef}>
                {images.map((src, index) => (
                    // <div className="banner-slide" key={index}>
                    //     <img src={src} draggable={false} alt={`Slide ${index + 1}`} />
                    // </div>
                    <Link to={'/services&pricing'} state={navigationData[index]} className="banner-slide" key={index}>
                        <img src={src} draggable={false} alt={`Slide ${index + 1}`} />
                    </Link>
                ))}
            </div>
            <div className='navigation_dots'>
                {
                    images.map((_, index) => (
                        <div className={currentIndex == index ? 'dot active' : 'dot'} onClick={() => currentIndex != index && setCurrentIndex(index)} />
                    ))
                }
            </div>
        </section>
    )
}

export default HomePageBanner